import React from "react";

/* eslint-disable max-len */
export default function ReactionIcon({size}: {size?: number}) {
    return (
        <svg width={size || 10} height={size || 10} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M5 9.5C7.48528 9.5 9.5 7.48528 9.5 5C9.5 2.51472 7.48528 0.5 5 0.5C2.51472 0.5 0.5 2.51472 0.5 5C0.5 7.48528 2.51472 9.5 5 9.5ZM6.5 4C6.77614 4 7 3.77614 7 3.5C7 3.22386 6.77614 3 6.5 3C6.22386 3 6 3.22386 6 3.5C6 3.77614 6.22386 4 6.5 4ZM4 3.5C4 3.77614 3.77614 4 3.5 4C3.22386 4 3 3.77614 3 3.5C3 3.22386 3.22386 3 3.5 3C3.77614 3 4 3.22386 4 3.5ZM5 7.5C3.89543 7.5 3 6.60457 3 5.5H7C7 6.60457 6.10457 7.5 5 7.5Z" fill="#63666A"/>
        </svg>
    );
}
